import { useState, useEffect } from 'react';
import { useGlobal } from './global';

export const useQpms = () => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [qpms, setQpms] = useState([]);

  const update = async (url, window, proxy) => {
    if (!fox) {
      return;
    }

    setLoading(true);
    const params = { url, window };
    if (proxy) {
      params.proxy = proxy;
    }
    console.log('call with params', fox, params);
    fox
      .call('GET', '/api/metrics/qpms', params)
      .then(({ data }) => setQpms(data))
      .finally(() => {
        setLoading(false);
      });
  };

  return { loading, qpms, update };
};

export const useEvals = () => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [evals, setEvals] = useState();

  const update = () => {
    setLoading(true);
    return fox
      .call('GET', '/api/metrics/evals', {})
      .then(({ results }) => setEvals(results))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!fox) {
      return;
    }
    update();
  }, [fox]);

  return { loading, evals, update };
};

export const useProxyTable = () => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [choice, setChoice] = useState({});
  const [table, setTable] = useState([]);

  const update = async (url, days) => {
    if (!fox) {
      return;
    }

    setLoading(true);
    const params = { url, days };
    console.log('call with params', fox, params);
    fox
      .call('GET', '/api/metrics/proxy/table', params)
      .then(({ data }) => {
        setChoice(data.choice || {});
        setTable(data.table || []);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { loading, choice, table, update };
};

export const useUserMetrics = () => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [metrics, setMetrics] = useState({});

  useEffect(() => {
    setLoading(true);

    if (!fox) {
      return;
    }

    fox.call('GET', '/api/metrics/users/retention').then((data) => {
      setMetrics(data);
      setLoading(false);
    });
  }, [fox]);

  return { loading, metrics };
};

export const useUserActivity = (username) => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [activity, setActivity] = useState({});

  useEffect(() => {
    setLoading(true);

    if (!fox) {
      return;
    }
    if (!username) {
      return;
    }

    fox.call('GET', '/api/metrics/users/activity', { username }).then((data) => {
      setActivity(data);
      setLoading(false);
    });
  }, [fox, username]);

  return { loading, activity };
};

export const useFinanceMetrics = (apiKey) => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [metrics, setMetrics] = useState({});

  useEffect(() => {
    setLoading(true);

    if (!fox) {
      return;
    }

    fox.call('GET', '/api/metrics/finances', apiKey ? { apiKey } : {}).then((data) => {
      setMetrics(data);
      setLoading(false);
    });
  }, [fox, apiKey]);

  return { loading, metrics };
};
